import { useState } from 'react'
import './LoginPage.css'
import { login } from '../../utils/authHelper'
import { saveSessionUser } from '../../utils/sessionHelper'

const LoginPage: React.FC = () => {
    const [username, setUsername] = useState('')
    const [password, setPassword] = useState('')
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [error, setError] = useState<string | null>(null)

    const submit = async (e: React.FormEvent) => {
        e.preventDefault()
        if (isSubmitting) return

        setIsSubmitting(true)
        setError(null)

        try {
            const data = await login(username, password)

            if (!data.success) {
                setError('Nicht korrekt. Bitte prüfe Nutzername und Passwort.')
                return
            }

            saveSessionUser(data.user)
            window.location.href = '/welcome'
        } catch {
            setError('Nicht korrekt. Bitte versuche es erneut.')
        } finally {
            setIsSubmitting(false)
        }
    }

    return (
        <main className='authPage'>
            <div className='authCard'>
                <img
                    className='authLogo'
                    src='https://www.familienkost.de/icon-svgs/logos/Familienkost_Logo_Horizontal_Farbig.svg'
                    alt='Familienkost Logo'
                />

                <div className='authEmblem' aria-hidden='true'>
                    <span>🔐</span>
                </div>

                <h1 className='authTitle'>Anmelden</h1>

                {error && <p className='authSubtitle'>{error}</p>}

                <form className='authForm' onSubmit={submit}>
                    <label className='authLabel'>
                        <span>Nutzername</span>
                        <input
                            className='authInput'
                            type='text'
                            placeholder='Max Mustermann'
                            value={username}
                            onChange={e => setUsername(e.target.value)}
                            autoComplete='username'
                            required
                        />
                    </label>

                    <label className='authLabel'>
                        <span>Password</span>
                        <input
                            className='authInput'
                            type='password'
                            placeholder='••••••••'
                            value={password}
                            onChange={e => setPassword(e.target.value)}
                            autoComplete='current-password'
                            required
                        />
                    </label>

                    <button className='authButton authButtonPrimary' type='submit' disabled={isSubmitting}>
                        {isSubmitting ? 'Sende…' : 'Senden'}
                    </button>
                </form>

                <p className='authFooter'>
                    © Familienkost ·{' '}
                    {new Date().toLocaleDateString('de-DE', { month: 'long', year: 'numeric' })}
                </p>
            </div>
        </main>
    )
}

export default LoginPage